import React from 'react';
import './PageLoader.css';

/**
 * LOADING COMPONENT
 * Shown while lazy-loaded pages are being fetched
 */

const PageLoader: React.FC = () => {
  return (
    <div className="page-loader">
      <div className="page-loader-spinner" />
      <p className="page-loader-text">Loading...</p>
    </div>
  );
};

export default PageLoader;

